<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading || refreshing"
    class="card"
  >
    <div
      v-if="data"
      slot="header"
      class="clearfix"
      :style="{
        background: data.isDeleted
          ? 'linear-gradient(to right, rgba(223, 171, 171, 0.589), transparent 50%)'
          : 'initial'
      }"
    >
      <div class="header">
        <div class="header__title">
          <el-tooltip
            v-if="data.lastVerifiedAt && data.verifiedHasData"
            placement="top"
          >
            <div slot="content">
              Проверено: {{ $dayjs(data.lastVerifiedAt).format("DD.MM.YYYY HH:mm") }}<br />
              Расчётный баланс: {{ data.verifiedComputedBalance }}<br />
              Разница: {{ data.verifiedDelta }}<br />
              Внутренних разрывов в истории: {{ data.verifiedBreaksCount }}<br />
              <template v-if="data.vwap !== null">
                VWAP: {{ numToString(data.vwap) }} ₽ за 1 {{ data.vwapValuteName }}
                (по {{ data.vwapVolume }} {{ data.vwapValuteName }})
              </template>
            </div>
            <i
              :class="
                data.verifiedIsConsistent ? 'el-icon-success' : 'el-icon-warning'
              "
              :style="{
                color: data.verifiedIsConsistent ? 'rgb(100,200,28)' : 'red'
              }"
              class="integrity-dot"
            ></i>
          </el-tooltip>
          <el-tooltip v-else-if="data.lastVerifiedAt" placement="top">
            <div slot="content">
              Проверено: {{ $dayjs(data.lastVerifiedAt).format("DD.MM.YYYY HH:mm") }}<br />
              Нет ни одной проводки с записанным балансом после — целостность
              не оценивается
            </div>
            <i
              class="el-icon-info integrity-dot"
              style="color: #909399;"
            ></i>
          </el-tooltip>
          <el-popover
            placement="bottom"
            title="Баланс удален"
            width="200"
            trigger="hover"
            v-if="data.isDeleted"
          >
            <template>
              Этот баланс был помечен удаленным, он больше не актуален.
            </template>
            <span slot="reference" style="text-decoration: line-through;">
              {{ data.title }}
            </span>
          </el-popover>
          <el-popover
            placement="top"
            :title="data.title"
            width="200"
            trigger="hover"
            v-else
          >
            <span slot="reference">
              {{ data.title }}
            </span>
          </el-popover>
          <!-- <el-popover
            placement="bottom"
            title="Баланс подробно"
            width="200"
            trigger="click"
            @show="getAllData"
          >
            <template>
              {{ allData }}
            </template>
            <span slot="reference">
              {{ data.title }}
            </span>
          </el-popover> -->
        </div>
        <div class="header__button" v-if="data && data._id">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-s-order"
            circle
            @click="
              $router.push({
                name: 'BalanceFull',
                params: { id: data._id }
              })
            "
          ></el-button>
        </div>
        <div class="header__button">
          <el-button
            @click="handleDelete"
            type="primary"
            icon="el-icon-close"
            circle
            size="mini"
          ></el-button>
        </div>
      </div>
    </div>
    <div class="content" v-if="data">
      <div>
        {{ getFixedValue(data) }}
        {{ data.valute ? data.valute.name : "" }}
      </div>
      <div class="small">{{ updatedAgoReadable }}</div>
    </div>
    <div class="content" v-for="pd in prevData">
      <div v-if="pd.balance" class="small">
        {{ getFixedValue(pd) }} {{ pd.valute ? pd.valute.name : "" }}
      </div>
      <div class="small">{{ getAgo(pd) }}</div>
    </div>
    <div class="content" v-if="!data && !loading">
      <div>
        Баланс отсутствует или был удален!
        <el-button @click="handleDelete" type="text">Удалить элемент</el-button>
      </div>
    </div>
  </el-card>
</template>
<script>
import { getBalanceAccounts, getAllBalances } from "@/api";
import { mapActions } from "vuex";

export default {
  name: "DashboardBalanceElement",
  data: () => ({
    loading: true,
    data: null,
    updatedAgo: 0,
    updatedAgoInterval: null,
    prevData: [],
    fixOptions: {
      BTC: 6,
      ETH: 6,
      default: 2
    },
    allData: null
  }),
  props: {
    balanceElement: {
      type: Object,
      required: true
    },
    // Значение баланса приходит батч-запросом от родителя (dashboard.vue),
    // а не запрашивается каждым виджетом отдельно.
    balanceData: {
      type: Object,
      default: null
    },
    // Признак того, что родитель сейчас выполняет батч-обновление всех
    // виджетов — используется только для индикации (спиннер на карточке).
    refreshing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    updatedAgoReadable() {
      if (!this.updatedAgo) return "N/A";
      return `${this.timeAgo(this.updatedAgo)}`;
    }
  },
  watch: {
    balanceData: {
      immediate: true,
      handler(newData) {
        this.applyData(newData);
        this.loading = false;
      }
    }
  },
  methods: {
    ...mapActions("ledgerDashboards", ["deleteDashboardElement"]),
    applyData(newData) {
      if (this.data && newData && this.data.updatedAt !== newData.updatedAt) {
        this.prevData.unshift({ ...this.data });
        if (this.prevData.length > 5) this.prevData.pop();
      }
      this.data = newData ? { ...newData } : null;
      this.updatedAgo = this.data && this.data.updatedAt
        ? this.$dayjs(new Date()).diff(this.$dayjs(this.data.updatedAt))
        : 0;
    },
    getAgo(data) {
      if (!data.updatedAt) return "N/A";
      const msAgo = this.$dayjs(new Date()).diff(
        this.$dayjs(data["updatedAt"])
      );
      return this.timeAgo(msAgo);
    },
    async handleDelete() {
      try {
        await this.deleteDashboardElement(this.balanceElement._id);
        this.$emit("deleted");
        return this.$notify.success({
          title: "Успех",
          message: `Элемент удален!`
        });
      } catch (error) {
        this.handleResponseError(error);
      }
    },
    async getAllData() {
      try {
        const { data } = await getAllBalances({
          id: this.balanceElement.balanceAccount
        });
        this.allData = data.result;
      } catch (error) {
        this.allData = error.response.data.message;
      }
    },
    getFixedValue(data) {
      return data.balance;
      return data.valute &&
        data.valute.name &&
        this.fixOptions[data.valute.name]
        ? +data.balance.toFixed(this.fixOptions[data.valute.name])
        : +data.balance.toFixed(this.fixOptions["default"]);
    }
  },
  mounted() {
    this.updatedAgoInterval = setInterval(() => {
      this.updatedAgo = this.data && this.data.updatedAt
        ? this.$dayjs(new Date()).diff(this.$dayjs(this.data.updatedAt))
        : 0;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.updatedAgoInterval);
  }
};
</script>
<style scoped>
.card {
  min-width: 200px;
  width: 280px;
}
.content {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.header__title {
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.integrity-dot {
  margin-right: 4px;
  font-size: 14px;
  vertical-align: -1px;
}
.header__button {
  height: 28px;
}
.small {
  /* margin-top: 1rem; */
  font-size: 0.65rem;
  margin-left: 0.2rem;
  color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/Dashboard/balance.vue